module.exports = "/wp-content/themes/onnit/script/cart/dist/abiOverrideMobile-d60a833c.png";